import React, { useState, useEffect } from 'react';
import AddEditConfigDialog from './addEditConfigDialog/AddEditConfigDialog';
import ConfigSummaryCard from './ConfigSummaryCard';
import { createConfig, getConfigs, getDropdowns, getFilterReqObj, getFormattedVendorConfig, hardcodeDropdown, updateConfig } from './services';
import EmptyListPlaceholder from '../../epmrConfigs/EmptyListPlaceHolder';
import AFilterForm from 'components/AFilterForm/AFilterForm';
import EmprConfigHeaderCard from '../../epmrConfigs/EpmrConfigHeader';
import ALoader from 'views/pages/manage/common/a-loader';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import styles from "./styles.module.scss";
// import { ReactComponent as FunnelIcon } from "assets/img/svg/svgComponents/FunnelIcon";
import FunnelIcon from "assets/img/svg/svgComponents/FunnelIcon";
import { getFilterFormFields } from './addEditConfigDialog/utils';
import { getAppliedFilterCount } from 'modules/studentTransfer/components/searchStudent/studentTransfersListing/utils';



const VendorApprovalConfigsListing = ({ userPermissions }) => {
    const isCreatePermission = checkPermission(userPermissions, "C");
    const isUpdatePermission = checkPermission(userPermissions, 'U');
    const isDeletePermission = checkPermission(userPermissions, 'D');

    const [form, setForm] = useState(null);
    const [vendorApprovalConfigs, setVendorApprovalConfigs] = useState([]);
    const [dropdownData, setDropdownData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [buLoading, setBuLoading] = useState(false);
    const [filterForm, setFilterForm] = useState({});

    const handleForm = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

    const closeAddEditConfigDialog = () => {
        setForm(null);
    }
    const addEditConfigDialogOpen = !!form;

    const getAllVendorApprovalConfig = async (filters = filterForm, dropdowns = dropdownData) => {
        try {
            setLoading(true);
            const resp = await getConfigs(getFilterReqObj(filters, dropdowns?.allActiveBu));
            const vendorConfigs = resp?.data?.data ?? [];
            setVendorApprovalConfigs(vendorConfigs?.map(config => getFormattedVendorConfig(config, dropdowns)));
            setFilterForm(prev => ({
                ...prev,
                appliedFilterCount: getAppliedFilterCount(filters)
            }))
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const init = async () => {
        try {
            setLoading(true);
            const dropdownData = await getDropdowns();
            setDropdownData(dropdownData);
            getAllVendorApprovalConfig({}, dropdownData)

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const createUpdateConfigHandler = async () => {
        try {
            setLoading(true);
            const resp = await (form?.isNew ? createConfig(form) : updateConfig(form));
            if (resp?.code === 200) {
                successToast("Request completed successfully!");
                getAllVendorApprovalConfig();
                closeAddEditConfigDialog();
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const editConfigHandler = async config => {
        try {
            setForm(config);
        } catch (err) {
            console.error(err);
        }
    }

    const handleFilterForm = (key, val) => setFilterForm(prev => ({ ...prev, [key]: val }));

    const removeFilterHandler = async () => {
        await getAllVendorApprovalConfig({}, dropdownData);
        setFilterForm({});
    }

    useEffect(() => {
        init();
    }, [])

    const addConfigHandler = () => setForm({
        isNew: true,
        rolesByLevel: {
            1: [],
            2: [],
            3: [],
            4: []
        }
    });


    return (
        <>
            {loading && <ALoader position="fixed" />}

            <EmprConfigHeaderCard
                addConfigHandler={addConfigHandler}
                isCreatePermission={isCreatePermission}
                heading='Vendors approval config'
                filters={
                    <div className="d-flex align-items-center">
                        <AFilterForm
                            btnComponent={
                                <div className={styles['filter-icon-container']}>
                                    <FunnelIcon width={17} height={17} stroke="#00B0F5" />
                                    <span className={styles['filter-text']}>Filter</span>
                                </div>
                            }
                            formFields={getFilterFormFields({ ...dropdownData, vendorTypes: hardcodeDropdown.vendorTypes })}
                            filterForm={filterForm}
                            handleFilterForm={handleFilterForm}
                            applyFilterHandler={getAllVendorApprovalConfig}
                            removeFilterHandler={removeFilterHandler}
                        />
                    </div>
                }
            />
            {vendorApprovalConfigs?.length != 0
                ? <div className={`p-3 ${styles['config-cards-container']}`}>
                    {vendorApprovalConfigs?.map(config =>
                        <ConfigSummaryCard
                            key={config?.id}
                            config={config}
                            editConfigHandler={editConfigHandler}
                            isUpdatePermission={isUpdatePermission}
                            loading={loading}
                        />)}
                </div>
                : <EmptyListPlaceholder
                    addConfigHandler={addConfigHandler}
                    isCreatePermission={isCreatePermission}
                    title='Click here to add first configuration for vendors'
                />
            }


            <AddEditConfigDialog
                open={addEditConfigDialogOpen}
                handleClose={closeAddEditConfigDialog}
                form={form}
                setForm={setForm}
                handleForm={handleForm}
                dropdownData={dropdownData}
                createUpdateConfigHandler={createUpdateConfigHandler}
                buLoading={buLoading}
                loading={loading}
            />

        </>
    )
}

export default VendorApprovalConfigsListing